import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-center" data-id="element-68">
      <div className="max-w-4xl mx-auto px-4" data-id="element-69">
        <div className="text-2xl font-bold text-white mb-6 flex items-center justify-center gap-2" data-id="element-70">
          🛼 PATÍN 360™
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mb-8 text-sm" data-id="element-71">
          <a href="mailto:contacto@patin360.com.ar" className="hover:text-white transition-colors" data-id="element-72">
            📧 contacto@patin360.com.ar
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-73">
            📲 @patin360.ar
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-74">
            🌐 www.patin360.ar
          </a>
        </div>

        <p className="text-xs" data-id="element-75">
          © PATÍN 360™ 2025 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
};